export const en = {
  task_assigned: {
    title: "Task Assigned",
    message: "A new task has been assigned to you",
    emailSubject: "New Task Assigned to You",
  },
  task_unassigned: {
    title: "Task Unassigned",
    message: "A task has been reassigned from you",
    emailSubject: "Task Removed From Your Queue",
  },
  team_task_assigned: {
    title: "Team Task Assigned",
    message: "A task has been assigned to a member of your team",
    emailSubject: "Team Task Assigned",
  },
  invitation_accepted: {
    title: "Invitation Accepted",
    message: "{{name}} has accepted your invitation and joined as {{role}}",
    emailSubject: "Invitation Accepted",
  },
  activity_snooze_expired: {
    title: "Snooze Expired",
    message: "A snoozed activity is ready for follow-up",
    emailSubject: "Snooze Expired — Activity Ready",
  },
  defaultEmailSubject: "OrderHub Notification",
  emailFooter: "This is an automated notification from OrderHub.",
} as const;
